import React from 'react'
import animateScroll from 'react-scroll/modules/mixins/animate-scroll'
import Button from '../../button'

import styles from './back-to-top.css'

function scrollToTop() {
  const options = {
    duration: 1000,
    smooth: 'easeOutCubic'
  }

  return animateScroll.scrollToTop(options)
}

function BackToTop() {
  return (
    <Button
      wrapperClassName={styles.backToTopWrapper}
      className={styles.button}
      onClick={scrollToTop}
      text="BACK TO TOP"
      darkBGSecondary
    />
  )
}

export default BackToTop
